export const HEADER_IDS = {
    DATE: 'date',
    AGENCY: 'agency',
    LONG_TERM: 'ratingLongTerm',
    SHORT_TERM: 'ratingShortTerm',
    OUTLOOK: 'outlook',
    SOURCE_LINK: 'sourceLink',
} as const;

export const headers = [
    { id: HEADER_IDS.DATE, label: 'Date' },
    { id: HEADER_IDS.AGENCY, label: 'Agency' },
    { id: HEADER_IDS.LONG_TERM, label: 'Long Term Rating' },
    { id: HEADER_IDS.SHORT_TERM, label: 'Short Term Rating' },
    { id: HEADER_IDS.OUTLOOK, label: 'Outlook' },
    { id: HEADER_IDS.SOURCE_LINK, label: 'Source' },
];

export const UNRATED_MESSAGE = 'No public credit ratings found for this company within the last 48 months';
